<template>
  <div id="app">
    <router-view />
    <a-back-top />
  </div>
</template>

<script>
import enquireScreen from "./utils/device";

export default {
  name: "App",
  created() {
    let _this = this;
    enquireScreen(isMobile => {
      _this.$store.commit("AppSetting/setDevice", isMobile);
    });
  }
};
</script>

<style lang="less">
:global {
  .dragable-ghost {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .dragable-chose {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .dragable-drag {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .page-toggle-enter-active {
    transition: all 0.2s ease-in 0.25s;
  }
  .page-toggle-leave-active {
    transition: all 0.2s ease-out 0s;
  }
  .page-toggle-enter,
  .page-toggle-leave-to {
    opacity: 0;
    padding: 0px;
  }
}
</style>
